import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { capitalize } from 'lodash'
import { Title, BackLink, PageHeader, Button } from '../components'
import germanChannels from '../channels/languages/german'
import englishChannels from '../channels/languages/english'
import spanishChannels from '../channels/languages/spanish'
import frenchChannels from '../channels/languages/french'


const VideosPage = ({ intl }) => {
  const subjects = ['english', 'german', 'spanish', 'french']
  const [selectedSubject, setSelectedSubject] = useState('english')

  function handleSelectedSubjectChange(subject) {
    setSelectedSubject(subject)
  }

  const channels = {
    'english': englishChannels,
    'german': germanChannels,
    'spanish': spanishChannels,
    'french': frenchChannels,
  }

  return <div className="page">
    <BackLink />
    <PageHeader
      title={intl.formatMessage(messages.title)}
    />
    <div className="flex-row width-full vertical-spacing">
      {
        subjects.map(subject => (
          <Button
            key={subject}
            className={selectedSubject === subject ? 'blue-button disable-spacing-left': 'disable-spacing-left'}
            onClick={() => handleSelectedSubjectChange(subject)}
          >
            {capitalize(subject)}
          </Button>
        ))
      }
    </div>
    <h2 className="large-vertical-spacing">
      {capitalize(selectedSubject)}
    </h2>
    <div className="flex-column width-full">
    {
      channels[selectedSubject].map(channel => (
        <div className="item-box" key={channel.id}>
          <Link to={`/videos/${selectedSubject}/${channel.id}`}>
            <h3>
              {channel.name}
            </h3>
            <span>
              {intl.formatMessage(messages.subscribers)}: {channel.subscribers ? channel.subscribers : '?'}
            </span>
          </Link>
        </div>
      ))
    }
    </div>
  </div>
}

VideosPage.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(VideosPage)

const messages = defineMessages({
  title: {
    id: 'videos.page.title',
    defaultMessage: 'Videá',
  },
  subscribers: {
    id: 'videos.page.subscribers',
    defaultMessage: 'Odberatelia',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/VideosPage.js